import {ChangeDetectorRef, Component, QueryList, ViewChildren} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../cc-base.component";
import {CcFormComponent} from "./cc-form.component";

@Component({
  template: '',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class CcSubFormBaseComponent extends CcBaseComponent {

  @ViewChildren('ccForm')
  formComponents: QueryList<CcFormComponent>;

  constructor(protected cdref: ChangeDetectorRef,
              protected messageService: MessageService,
              protected translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  public reloadFieldValueMap(): void {
    if (this.formComponents)
      this.formComponents.forEach(ccForm => ccForm.reloadFieldValueMap());
    this.markForCheck();
  }

}
